<div class="nk-search-dropdown py-1" [class.hidden]="!openDropdown" [attr.data-cy]="'company-person-search-results'">
  <div class="m-2 nk-search-inner">
    @if (orderedListByType$ | async; as orderedListByType) {
      @if (orderedListByType.all.length === 0) {
        <div class="text-muted small">
          {{ 'simple_search.search_helptext' | translate }}
        </div>
      }
      @if (orderedListByType.quickCompanies.length > 0) {
        <div>
          <i class="fa fa-building-o float-end me-2 mt-1"></i>
          <p class="px-1 mb-1 font-weight-bold" [attr.data-cy]="'company-person-search-company-section-label'">
            {{ 'simple_search.company_section_label' | translate }}
          </p>
          @for (item of orderedListByType.quickCompanies; track $index) {
            <nk-company-person-search-option
              [item]="item"
              [selectedItemIndex]="selectedItemIndex"
              [disableEnterKey]="disableEnterKey"
              (click)="onItemClick(item)"
              [searchQuery]="query"></nk-company-person-search-option>
          }
        </div>
      }

      @if (
        orderedListByType.quickCompanies.length > 0 &&
        (orderedListByType.quickPerson.length > 0 || orderedListByType.fuzzy.length > 0)
      ) {
        <hr class="my-2" />
      }
      @if (orderedListByType.quickPerson.length > 0) {
        <div>
          <i class="fa fa-user-o float-end me-2 mt-1"></i>
          <p class="px-1 mb-1 font-weight-bold" [attr.data-cy]="'company-person-search-person-section-label'">
            {{ 'simple_search.persons_section_label' | translate }}
          </p>
          @for (item of orderedListByType.quickPerson; track $index) {
            <nk-company-person-search-option
              [item]="item"
              [selectedItemIndex]="selectedItemIndex"
              [disableEnterKey]="disableEnterKey"
              (click)="onItemClick(item)"
              [searchQuery]="query"></nk-company-person-search-option>
          }
        </div>
      }
      @if (orderedListByType.quickPerson.length > 0 && orderedListByType.fuzzy.length > 0) {
        <hr class="my-2" />
      }
      <div>
        @if (orderedListByType.fuzzy.length > 0) {
          <p class="px-1 mb-1 font-weight-bold">
            {{ 'simple_search.more_hits_section_label' | translate }}
          </p>
        }
        @for (item of orderedListByType.fuzzy; track $index) {
          <nk-company-person-search-option
            [item]="item"
            [selectedItemIndex]="selectedItemIndex"
            [disableEnterKey]="disableEnterKey"
            (click)="onItemClick(item)"
            [searchQuery]="query"></nk-company-person-search-option>
        }
      </div>
    }
  </div>
</div>
